'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const $ = require("jquery");
class Modal {
    constructor() {
        // 「製品情報から知る」「技術情報から知る」のモーダル
        $('.trigShowModalContent').on('click', (e) => {
            const contentType = $(e.currentTarget).attr('data-type');
            $(`.bulletModalContent[data-type="${contentType}"]`).attr('data-is-show', 'true');
        });
        // ✕か背景押したらモーダル閉じる
        $('.trigCloseModalContent').on('click', (e) => {
            if (!$(e.target).closest('.paramModalContent').length) {
                $('.bulletModalContent').attr('data-is-show', 'false');
            }
        });
        $('.trigSwitchRootMap').on('click', (e) => {
            const isMobile = window.matchMedia("(max-width: 767px)").matches;
            let topMargin = 20;
            let bottomMargin = 50;
            let navigationHeight = $('.paramNavigation').outerHeight() || 0;
            if (isMobile) {
                topMargin = 10;
                bottomMargin = 10;
                navigationHeight = 0;
            }
            const browserHeight = $(window).height();
            const headerHeight = $('.paramHeader').outerHeight() || 0;
            $('.modal').css({
                'height': `${browserHeight - headerHeight - navigationHeight - topMargin - bottomMargin}px`,
                'top': `${headerHeight + topMargin}px`
            });
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                // fadeinの後に、CSSでdisplay: flexにする
                $('.bulletOverLay').fadeIn('slow', () => {
                    $(e.currentTarget).attr('data-is-open', 'true');
                }).css('display', 'flex');
            }
            else {
                $('.bulletOverLay').fadeOut('slow', () => {
                    $(e.currentTarget).attr('data-is-open', 'false');
                });
            }
            $('.trigCloseOverLay').on('click', () => {
                $('.bulletOverLay').fadeOut('slow', () => {
                    $(e.currentTarget).attr('data-is-open', 'false');
                });
            });
        });
    }
}
exports.Modal = Modal;
exports.default = Modal;
